import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="about-card-view">
      <Card.Body>
        <p className="about-intro">
          I&apos;m <span className="purple">Azka Bashir</span>, a full-stack
          JavaScript developer based in <span className="purple">Dubai, UAE</span>
          . I turn ideas into polished products you can launch with confidence.
        </p>

        <p className="about-intro">
          You work with one partner from frontend to backend to deployment—not
          three separate vendors trying to fit pieces together.
        </p>

        <div className="about-value-list">
          <h3 className="about-value-heading">What you get working with me</h3>
          <ul>
            <li className="about-activity">
              <ImPointRight /> One timeline, one point of contact—from idea to production
            </li>
            <li className="about-activity">
              <ImPointRight /> Honest updates and delivery you can plan around
            </li>
            <li className="about-activity">
              <ImPointRight /> Products built for speed, UX, and real business results
            </li>
            <li className="about-activity">
              <ImPointRight /> Post-launch support to keep growing users and revenue
            </li>
          </ul>
        </div>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
